export enum PaymentGatewayProvider {
  Stripe = 'Stripe',
  Esewa = 'Esewa',
  Paytabs = 'Paytabs',
  Venmo = 'Venmo',
  Flutterwave = 'Flutterwave',
  // Add more payment gateway providers here later
}

export interface PaymentGateway {
  id: number;
  provider: PaymentGatewayProvider;
  gatewayAccountId: string; // The account ID for the payment gateway provider
  metaData: object | null; // Additional metadata, nullable
}

export interface PaymentGatewayProviderConfiguration {
  name: string;
  logo: string;
  /** The gateway confirms payment itself; when false (Venmo) the salon reconciles it manually. */
  automaticSettlement: boolean;
  /** The gateway can save a card for the card-on-file deposit policy. Mirrors the API's `PAYMENT_GATEWAY_CAPABILITIES`. */
  cardOnFile: boolean;
  /** Widget checkout page for gateways with `automaticSettlement`; manually reconciled ones (Venmo) go straight to thank-you. */
  checkoutRoute?: string;
  description?: string;
  // fields?: PaymentGatewayFieldDefinition[];
}

export const PAYMENT_GATEWAY_PROVIDER_CONFIGURATIONS = {
  [PaymentGatewayProvider.Stripe]: {
    name: 'Stripe',
    logo: 'stripe.png',
    description: 'Credit cards and digital wallets',
    automaticSettlement: true,
    cardOnFile: true,
    checkoutRoute: 'payment',
  },
  [PaymentGatewayProvider.Esewa]: {
    name: 'eSewa',
    logo: 'esewa.png',
    description: 'Mobile wallet, QR codes and app payments',
    automaticSettlement: true,
    cardOnFile: false,
    checkoutRoute: 'payment-esewa',
  },
  [PaymentGatewayProvider.Paytabs]: {
    name: 'PayTabs',
    logo: 'paytabs.png',
    description: 'Cards, for MENA/GCC locations',
    automaticSettlement: true,
    cardOnFile: false,
    checkoutRoute: 'payment-paytabs',
  },
  [PaymentGatewayProvider.Venmo]: {
    name: 'Venmo',
    logo: 'venmo.png',
    description: 'App-to-app mobile links',
    automaticSettlement: false,
    cardOnFile: false,
  },
  [PaymentGatewayProvider.Flutterwave]: {
    name: 'Flutterwave',
    logo: 'flutterwave.png',
    description: 'Cards, mobile money, bank transfers and USSD',
    automaticSettlement: true,
    cardOnFile: false,
    checkoutRoute: 'payment-flutterwave',
  },
} satisfies Record<PaymentGatewayProvider, PaymentGatewayProviderConfiguration>;
